import axios from "axios";
const token = JSON.parse(localStorage.getItem("TOKEN"))
const timezone = JSON.parse(localStorage.getItem("TIMEZONE"))

axios.defaults.timeout = 30000;
axios.defaults.timeoutErrorMessage='timeout'
if(token){
    axios.defaults.headers.common["x-access-token"] = token;
}
if(timezone){
    axios.defaults.headers.common["timezone"] = timezone?.timezone;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    User(url = `${process.env.REACT_APP_BASE_URL}/api/`) {
        return {
            addUserschedule: (data) => axios.post(url + "learner/addUserSchedule", data),
            magicLogin: (data) => axios.post(url + "learner/magic-login", data),
            updateUserschedule: (data) => axios.put(url + "learner/updateUserSchedule", data),
            userCurrentschedule: (data) => axios.post(url + "learner/getUserSchedule", data),
            updateLearnerPassword: (data) => axios.put(url + "learner/changePassword", data),
            updateLearnerProfile: (data) => axios.put(url + "learner/updateLearner", data),
            getRefferalData: (data) => axios.post(url + "learner/getReferralCode", data),
            getLearnerNotes: (data) => axios.post(url + "learner/getNotes", data),
            emailNotification: (data) => axios.post(url + "learner/saveEmail", data),
            emailUnsubscribe: (data) => axios.get(url + "learner/unsubscribedEmail", data),
            learnerWalletHistory: (data) => axios.post(url + "wallet/getWalletTransactions", data),
            word: () => axios.get(url + "images/getWord"),
            getTeacherNotes: () => axios.get(url + "teacher/getNotes"),
            getVideo: () => axios.get(url + "library/getVideos"),
            confirmDemoPayment: (data, demoToken) => {
                // console.log(demoToken)
                if (demoToken) {
                    axios.defaults.headers.common["x-access-token"] = demoToken;
                    return (
                        axios.post(url + "learner/confirmDemoPayment", data)
                    )
                }
                else {
                    return (axios.post(url + "learner/confirmDemoPayment", data))
                }
            },
            subscribe: (data, demoToken) => {
                if (demoToken) {
                    axios.defaults.headers.common["x-access-token"] = demoToken;
                    return (
                        axios.post(url + "learner/subscribe", data)
                    )
                }
                else {
                    return (
                        axios.post(url + "learner/subscribe", data)
                    )
                }
            },
            upgrade: (data) => axios.post(url + "learner/upgradeSubscription", data)
        }
    }
}